import { ExperienceTestTypeDto } from "@intelligems/ig-types/dtos/experiences";
import { WebUiScopesConfigurationKeyType } from "@intelligems/ig-types/dtos/configurations";

const CreateTestTypeMap: Record<
  keyof ExperienceTestTypeDto,
  Lowercase<WebUiScopesConfigurationKeyType>
> = {
  hasTestPricing: "create_price_experiment",
  hasTestShipping: "create_shipping_experiment",
  hasTestContentTemplate: "create_template_experiment",
  hasTestContentTheme: "create_theme_experiment",
  hasTestContent: "create_onsite_edits_experiment",
  hasTestCampaign: "create_discount_experiment",
  hasTestContentAdvanced: "create_content_experiment", // deprecated?
  hasTestContentOnsite: "create_onsite_edits_experiment",
  hasTestContentUrl: "create_redirect_experiment",
  hasTestOnsiteInjections: "create_onsite_edits_experiment",
  hasTestCheckoutBlocks: "create_checkout_block_test",
  hasTestPostPurchase: "create_checkout_block_test",
  hasTestOnsiteUpsell: "create_onsite_upsell",
};

const StartTestTypeMap: Record<
  keyof ExperienceTestTypeDto,
  Lowercase<WebUiScopesConfigurationKeyType>
> = {
  hasTestPricing: "start_price_experiment",
  hasTestShipping: "start_shipping_experiment",
  hasTestContentTemplate: "start_template_experiment",
  hasTestContentTheme: "start_theme_experiment",
  hasTestContent: "start_onsite_edits_experiment",
  hasTestCampaign: "start_discount_experiment",
  hasTestContentAdvanced: "start_content_experiment", // deprecated?
  hasTestContentOnsite: "start_onsite_edits_experiment",
  hasTestContentUrl: "start_redirect_experiment",
  hasTestOnsiteInjections: "start_onsite_edits_experiment",
  hasTestCheckoutBlocks: "start_checkout_block_test",
  hasTestPostPurchase: "start_checkout_block_test",
  hasTestOnsiteUpsell: "start_onsite_upsell",
};

const FriendlyTestTypeMap: Record<keyof ExperienceTestTypeDto, string> = {
  hasTestPricing: "pricing",
  hasTestShipping: "shipping",
  hasTestContentTemplate: "template",
  hasTestContentTheme: "theme",
  hasTestContent: "onsite edits",
  hasTestCampaign: "discount",
  hasTestContentAdvanced: "content", // deprecated?
  hasTestContentOnsite: "onsite edits",
  hasTestContentUrl: "redirect",
  hasTestOnsiteInjections: "onsite edits",
  hasTestCheckoutBlocks: "checkout",
  hasTestPostPurchase: "post-purchase",
  hasTestOnsiteUpsell: "onsite upsell",
};

export const experimentScopeMaps = {
  CreateTestTypeMap,
  StartTestTypeMap,
  FriendlyTestTypeMap,
};
